export function construirVenta({
  mesaId,
  total,
  metodoPago
}) {
  if (!mesaId) throw new Error("Mesa requerida");
  if (total == null) throw new Error("Total requerido");
  if (!metodoPago) throw new Error("Método de pago obligatorio");

  return {
    mesaId,
    total,
    metodoPago,
    estado: "pagada",
    fecha_registro: new Date().toISOString(),
  };
}
